import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants/tags';
import { getCountryStates } from '@module/mdrt-org/shared/utils/data/get-country-states';
export const useCountryStatesQuery = t0 => {
  const $ = _c(13);
  const {
    selectedCountryId
  } = t0;
  const t1 = Boolean(selectedCountryId);
  let t2;
  if ($[0] !== selectedCountryId) {
    t2 = async () => selectedCountryId ? await getCountryStates(selectedCountryId) : [];
    $[0] = selectedCountryId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${OrgSharedDataTag.GET_COUNTRY_STATES}_${selectedCountryId}`;
  let t4;
  if ($[2] !== t3) {
    t4 = [OrgSharedDataTag.GET_COUNTRY_STATES, t3];
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t4) {
    t5 = {
      enabled: t1,
      queryFn: t2,
      queryKey: t4
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: countryStatesData,
    isLoading: isCountryStatesDataLoading
  } = useQuery(t5);
  let t6;
  if ($[8] !== countryStatesData) {
    t6 = countryStatesData?.map(_temp) ?? [];
    $[8] = countryStatesData;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const stateOptions = t6;
  let t7;
  if ($[10] !== isCountryStatesDataLoading || $[11] !== stateOptions) {
    t7 = {
      isCountryStatesDataLoading,
      stateOptions
    };
    $[10] = isCountryStatesDataLoading;
    $[11] = stateOptions;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
function _temp(state) {
  return {
    label: state.stateName,
    value: state.id
  };
}